import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public isNavigationBlockedManually: boolean = false;

  constructor() {}
}
